import React from 'react';
import styles from './smart-layer.module.css';
// import isIPadAppFunction from "../../lib/xes/common.js";
import xesBridge from 'xes-code-base/lib/libs/xes'
import { connect } from "react-redux";
import DetailCard from "./detail-card.jsx";
import SmartCtrl from "../../lib/xes/smart-ctrl.js";
import PromptCard from "./prompt-card.jsx";
import PromptDialog from './prompt-dialog.jsx';
import AlertSomething from '../alert-something-modal/alert-something.jsx';
import { onXESCheck,onXESCheckBackGround,onXESConfirmSubmit } from "../../reducers/project-state.js";
import { sendIntelligentPromptView } from "../../lib/xes/log";

class smartLayer extends React.Component{
  constructor(){
    super();
    this.state = {
      isIpad: xesBridge.isIPadAppFunction(),
      current: 0,                   // tab标签id
      showContent: false,           // 是否显示智能提示内容
      showCtrlHeader: false,        // 是否显示控制头
      showPrompt: false,            // 是否显示锦囊
      showPromptDialog: false,      // 是否显示弹出框
      _showGoCheck: false,          // 是否显示弹出框"前往检查"按钮
      _showCheck: false,            // 是否显示检查结果Tab
      showProblemSolving: false,    // 是否显示解题思路Tab
      showKnowlege:false,           // 是否显示知识点Tab
      _showProblemSolving: false,   // 是否显示解题思路Tab【新版】
      _showKnowlege:false,          // 是否显示知识点Tab【新版】
      // 是否存在
      hasProblemSolving: false,     // SmartCtrl是否配置了解题思路
      hasKnowlege:false,            // SmartCtrl是否配置了知识点
      titleText:'',                 // 锦囊的文案标题         
      descText:'',                  // 锦囊的文案内容
      _titleText:'',                // 弹出框的文案标题
      _descText:'',                 // 弹出框的文案内容
      /* 按钮显示控制 */
      showBtnKit:false,             // 是否显示气泡锦囊
      isActive:true,                // 是否主动提交
      isEarly:false,                // 是否是早期
      isBlank:false,                // 是否空白
      showCheckTips: false,         // 是否显示三次检测提示气泡:"对解题有帮助哦"
      topTipsFlag: 0,               // 顶部气泡弹出标记:"点击可以查看问题及解题思路"
      _btnKitErr: false,            // 后期检测错误标记
      startTime: Date.now(),        // 记录初始时间
      timerCheckTips: null,         // "对解题有帮助哦" 定时器       
      timerTopTips: null,           // "点击可以查看问题及解题思路" 定时器
      disableTips: false,           // topTips自锁，只显示一次
      /* 附加题 */
      showNextProjectTips:false,    // 是否显示附加题顶部气泡提示
      onCloseNextProjectDialog:false,// 
      nextProjectDialogType:'default',
      nextProjectDialogGold: 0,
      nextProjectDialogTime: 0,
      nextProjectDialogSubmitTime: 0,
    }
    SmartCtrl.setHideAllCallBack(() => {
      this.setState({ showContent: false })
    })
    /* 传给SmartCtrl回调，显示控制头 */
    SmartCtrl.setShowCtrlHeader(() => {
      this.setState({ showCtrlHeader: true })
      this.itemNav(2)
    })
    /* 传给SmartCtrl回调，显示附加题提示 */
    SmartCtrl.setShowNextProjectTips(() => {
      this.setState({showNextProjectTips:true})
      setTimeout(()=>{
        this.setState({showNextProjectTips:false})
      },3000)
    })
    /* 传给SmartCtrl回调，显示附加题宝盒 */
    SmartCtrl.setShowNextProject((type,goldNum,surplusTime,submitTime)=>{
      this.setState({
        showNextProjectDialog:true,
        nextProjectDialogType:type,
        nextProjectDialogGold:goldNum,
        nextProjectDialogTime:surplusTime,
        nextProjectDialogSubmitTime:submitTime
      })
      SmartCtrl.closeTimingDetection()
    })
    SmartCtrl.setShowPromptMessageCallBack((showSubmit, showProblemSolving, showKnowlege,isActive,isEarly,isBlank) => {
      // 【showSubmit】【显示解题思路】【显示知识点】【是否主动触发】【是否是初期检测】【是否未作答】
      // console.log(showSubmit, showProblemSolving, showKnowlege,isActive,isEarly,isBlank)

      /* 检测配置的智能提示 【解题思路】【知识点】【答案解析】 */
      if( SmartCtrl.knowledgePoint === null || SmartCtrl.knowledgePoint.length === 0 ){
        this.setState({hasKnowlege: false})
      }else{
        this.setState({hasKnowlege: true})
      }
      if( SmartCtrl.solvingProblem === null || SmartCtrl.solvingProblem.length === 0 ){
        let _current = this.state._showCheck ? 2 : 1
        this.setState({hasProblemSolving: false,current: _current})
        /* |-- 课中题的【解题思路】和附加题的【答案解析】共用 [hasProblemSolving] 状态 */
        if(!( SmartCtrl.answerAnalysis === null || SmartCtrl.answerAnalysis.length === 0 )){
          let _current = this.state._showCheck ? 2 : 0
          this.setState({hasProblemSolving: true,current:_current})
        }
      }else{
        this.setState({hasProblemSolving: true})
      }
      if(showKnowlege && !this.state.hasKnowlege ){
        showKnowlege = false
        if(this.state.hasProblemSolving){
          showProblemSolving = true
        }
      }
      if(showProblemSolving && !this.state.hasProblemSolving){
        showProblemSolving = false
        if(this.state.hasKnowlege){
          showKnowlege = true
        }
      }
      // 设置状态
      this.reSetBtn()
      this.setState({showProblemSolving: showProblemSolving})
      this.setState({showKnowlege: showKnowlege})
      this.setState({isActive: isActive})
      this.setState({isEarly: isEarly})
      this.setState({ isBlank: isBlank })
      // this.setState({showPrompt: showProblemSolving||showKnowlege})
      

      // 都没有【没有配置解题思路和知识点】
      this.setState({_descText: '老师给你一个提示，看完再试一试吧'})
      if (!showProblemSolving && !showKnowlege) {
        this.setState({_descText: '检查功能可以帮你找出代码中的问题哦'})
        this.setState({current:2})
        if (!isActive) {/* 被动检查情况 */
          this.setState({ showBtnKit: false })
          this.setState({ titleText: '' })
          if (isEarly && isBlank) {
            this.setState({ descText: '老师发现你什么都没写！<br/>你要赶快作答哦！' })
            this.setState({showBtnKit: false})
            this.setState({showPrompt: true})
          }
          else if (!isEarly && isBlank) {
            this.setState({ descText: '时间马上到了！<br/>老师发现你什么都没写！加速作答吧！' })
            this.setState({showBtnKit: false})
            this.setState({showPrompt: true})
          }
          else if (!isEarly && !isBlank) {
            this.setState({ titleText: '答题时间马上到了！' })
            this.setState({ descText: '可以使用检查找出代码中的问题哦！' })
            this.setState({showBtnKit: false})
            this.setState({showPrompt: true})
          }
        } else {/* 主动提交情况 */
          if (showSubmit && isBlank) {/* 空白提交 */
            this.setState({ _titleText: '你什么都没写，确定要这样提交吗？'})
            // this.setState({_descText: ''})
            this.setState({showPromptDialog: true,showPrompt:false, _showGoCheck:true})
            this.itemNav(2)
          } else if (showSubmit && !isBlank) {/* 错误提交 */
            this.setState({ _titleText: '代码还有问题,提交得不到满分！' })
            // this.setState({ _descText: '检查面板能帮你找出代码中的问题哦' })
            this.setState({showPromptDialog: true,showPrompt:false,_showGoCheck:true})
            this.itemNav(2)
          }
        }
        return
      }
      // 被动提示
      // 初期 空白 -  - 解题思路
      // 后期 空白 -  - 解题思路
      if( !isActive && isBlank){
        this.setState({titleText: '老师发现你还没开始答题！'})
        this.setState({descText: '给了你一个锦囊，遇到困难就打开吧！'})
        this.setState({showBtnKit: true})
        this.setState({showPrompt: true})
        return
      }
      // 后期错误 - 锦囊
      if( !isActive && !isEarly && !isBlank){
        this.setState({titleText: '答题时间马上到了！'})
        this.setState({descText: '遇到困难就打开锦囊吧！'})
        this.setState({showBtnKit: true,_btnKitErr:true})
        this.setState({showPrompt: true})
        return
      }

      // 三次检测
      // 主动 空白  - 解题思路
      if( isActive && !isEarly && isBlank && !showSubmit){
        this.setState({_showProblemSolving:showProblemSolving,_showKnowlege:showKnowlege,showCheckTips:true,topTipsFlag:++this.state.topTipsFlag})
        this.setState({showPrompt:false})
        clearTimeout(this.state.timerCheckTips)
        this.state.timerCheckTips = setTimeout(()=>{
          this.setState({showCheckTips:false})
        },2000)
      }
      // 主动 错误 - 解题思路
      if( isActive && !isEarly && !isBlank && !showSubmit){
        this.setState({_showProblemSolving:showProblemSolving,_showKnowlege:showKnowlege,showCheckTips:true,topTipsFlag:++this.state.topTipsFlag})
        this.setState({showPrompt:false})
        clearTimeout(this.state.timerCheckTips)
        this.state.timerCheckTips = setTimeout(()=>{
          this.setState({showCheckTips:false})
        },2000)
      }

      // 提交
      // 主动 空白 - 解题思路
      // 主动 错误 - 解题思路
      if (showSubmit && isActive && !isEarly && isBlank){
        this.setState({ _titleText: '你什么都没写，确定要这样提交吗？'})
        // this.setState({_descText: '老师给你一个解题思路，看完再试试吧！'})
        this.setState({showPromptDialog: true,_showCheck:false,showPrompt:false, _showGoCheck:false,topTipsFlag:++this.state.topTipsFlag})
        if(this.state.showKnowlege){
          this.setState({current: 1,_showKnowlege:true})
        }
        if(this.state.showProblemSolving){
          this.setState({current: 0,_showProblemSolving:true})
        }
        this.setState({showContent: true})
        this.onCloseCheck()
      }  
      else if (showSubmit && isActive && !isEarly && !isBlank) {
        this.setState({ _titleText: '代码还有问题,提交得不到满分！' })
        // this.setState({ _descText: '检查面板能帮你找出代码中的问题哦' })
        this.setState({showPromptDialog: true,showPrompt:false,_showGoCheck:false,topTipsFlag:++this.state.topTipsFlag})
        if(this.state.showKnowlege){
          this.setState({current: 1,_showKnowlege:true})
        }
        if(this.state.showProblemSolving){
          this.setState({current: 0,_showProblemSolving:true})
        }
        // this.setState({showContent: true})
        this.itemNav(2)
      }  
      console.log('smartLayer是否显示检查结果,是否显示解题思路,是否显示知识点', showSubmit, showProblemSolving, showKnowlege)
    })
    SmartCtrl.setCheckCallBack(() =>{
      this.props.dispatch(onXESCheckBackGround('auto'))
    })
  }
  reSetBtn(){
    this.setState({showBtnKit: false})
    this.setState({isEarly: false})
    this.setState({isActive: false})
    this.setState({ isBlank: false })
  }
  triggerTab(index,hasAnalysis){
    /* 打点3.0 点击tab */
    sendIntelligentPromptView(
      hasAnalysis === true ? 'click_analysis' : (index === 0 ? 'click_solving' : 'click_knowledge')
    )
    this.itemNav(index)
  }
  itemNav(index) {
    this.setState({current: index})
    // 控制iframe层级
    if(index === 2){
      document.getElementsByTagName('iframe')[0].style.zIndex = '999'
      // document.getElementsByTagName('iframe')[0].style.display = 'block'
      this.setState({_showCheck:true})
    }else{
      document.getElementsByTagName('iframe')[0].style.zIndex = '0'
      this.setState({showContent: true})
    }
  }
  onSubmit(){
    this.props.dispatch(onXESConfirmSubmit())
    this.onClosePromptDialog() // 关闭dialog
  }
  // 当点击锦囊
  onClickKit(){
      this.setState({ showCtrlHeader: true,_showCheck:false,topTipsFlag:++this.state.topTipsFlag})
      if(this.state.hasKnowlege){
        this.setState({current: 1,_showKnowlege:true})
      }
      if(this.state.hasProblemSolving){
        this.setState({current: 0,_showProblemSolving:true})
      }
      // 后期检测错误，默认显示检查页面
      if(this.state._btnKitErr){
        this.props.dispatch(onXESCheck())
        // this.setState({disableTips:true})
        // this.itemNav(2)
      }
      // this.setState({showBtnKit: false})
      // this.setState({showPrompt: true})
      this.onShowContent()
  }
  onCloseContent(){
    if((this.state.topTipsFlag === 1) && !this.state.disableTips){
      this.setState({showCheckTopTips:true,disableTips:true})
      clearTimeout(this.state.timerTopTips)
      this.state.timerTopTips = setTimeout(()=>{
        this.setState({showCheckTopTips:false})
      },2000)
    }
    this.setState({
      showContent: false,
      showCtrlHeader: false
    })
    this.onCloseCheck()
  }
  // 关闭检测窗口
  onCloseCheck(){
    if (window.hideIframe) {
      window.hideIframe()
    }
  }
  onShowContent(){
    this.setState({showContent: true})
    this.setState({showPrompt: false})
    this.onCloseCheck()
  }
  onShowProblemSolving(){
    // this.setState({showProblemSolving:true,current:0})
    this.setState({showCtrlHeader: true,showPromptDialog:false})
    if(this.state.showKnowlege){
      this.setState({current: 1,_showKnowlege:true})
    }
    if(this.state.showProblemSolving){
      this.setState({current: 0,_showProblemSolving:true})
    }
    this.setState({showContent: true})
    this.setState({showPrompt: false})
    this.onCloseCheck()
  }
  // 关闭气泡提示
  onClosePrompt(){
    this.setState({showPrompt: !this.state.showPrompt})
  }
  // dialog - 关闭弹窗
  onClosePromptDialog(){
    this.setState({showPromptDialog: false})
  }
  /* 关闭附加题弹窗 */
  onCloseNextProjectDialog(){
    this.setState({showNextProjectDialog:false})
  }
  render(){
    return(
    <div>
        {/* 覆盖控制头 */}
        <div className={ (this.state.showCtrlHeader ? '':styles.hide) +' '+ styles.pcBackground +' '+ styles.ctrlHeader}>
          <div>
            <a onClick={ () => { this.onCloseContent()} } className={ styles.btnClose}  href='javascript:void(0)'></a>
            {
              this.state._showCheck ?
              <a href="javascript:void(0)" className={(2 === this.state.current ? styles.tabActive : '')+' '+styles.tab+' '+styles.tabTwo} onClick={()=>{this.itemNav(2)}}>检查结果</a>
              :null
            }
            {
              this.state._showProblemSolving ? 
              <a  href='javascript:void(0)' className={ (0 === this.state.current ? styles.tabActive : '') + ' '+styles.tab} onClick={ () => { this.triggerTab(0, SmartCtrl.answerAnalysis !== null)} }>
                {SmartCtrl.answerAnalysis === null ? '解题思路' : '答案解析'}
              </a>
              :null
            }
            {
              this.state._showKnowlege ? 
              <a  href='javascript:void(0)' className={ (1 === this.state.current ? styles.tabActive : '') + ' '+styles.tab} onClick={ () => { this.triggerTab(1)} }>知识点</a>
              :null
            }
            {
              this.state.showCheckTips ?
              <span className={styles.tabTips}>对解题有帮助哦</span>
              :null
            }
          </div>
        </div>
        {/* 顶部气泡 */}
        {
          this.state.showCheckTopTips ? 
          <span className={styles.topTips}>点击可以查看问题及解题思路</span>
          :null
        }
        {/* 附加题气泡 */}
        {
          this.state.showNextProjectTips ?
          <div className={styles.nextProjectTips}>完成本题有机会获得 <span>编程宝盒</span> 哦~</div>
          :null
        }

        <div className={ (this.state.showContent ? '':styles.hide) +' '+ styles.pcBackground}>
          <div className={ styles.contentArea}>
            <div className={styles.detailCard}>
              {/* {
                this.state.current==0 ? 
                <div>
                    <DetailCard 
                    type="SolvingProblem"
                    data  = {SmartCtrl.solvingProblem}
                    ></DetailCard>
                </div>
                :
                <div>
                <DetailCard 
                  data  = {SmartCtrl.knowledgePoint}
                ></DetailCard>
              </div>
              } */}

              <div className={ (this.state.current==0 ? '':styles.hide)}>
                  <DetailCard 
                  type="SolvingProblem"
                  data  = {SmartCtrl.solvingProblem || SmartCtrl.answerAnalysis}
                  ></DetailCard>
              </div>
              <div className={ (this.state.current==1 ? '':styles.hide)}>
                <DetailCard 
                  data  = {SmartCtrl.knowledgePoint}
                ></DetailCard>
              </div>
            </div>
          </div>
        </div>
        {
          this.state.showPrompt ?
            <div className={ (this.state.showPrompt ? '':styles.hide) +' '+ styles.pcPrompt} >
              <PromptCard
              titleText={this.state.titleText}
              descText={this.state.descText}
              isBlank={this.state.isBlank}
              isActive={this.state.isActive}
              isEarly={this.state.isEarly}
              showBtnKit={this.state.showBtnKit}
              onClosePrompt={ () => { this.onClosePrompt()} }
              onSubmit={()=>{this.onSubmit()}}
              onClickKit={()=>{this.onClickKit()}}
              onShowProblemSolving={()=>{this.onShowProblemSolving()}}
              ></PromptCard>
            </div>
            :null
        }
        {
          this.state.showPromptDialog ?
          <PromptDialog
          titleText={this.state._titleText}
          descText={this.state._descText}
          isBlank={this.state.isBlank}
          toCheck={this.state._showGoCheck}
          onClosePromptDialog={()=>{this.onClosePromptDialog()}}
          onShowProblemSolving={()=>{this.onShowProblemSolving()}}
          onSubmit={()=>{this.onSubmit()}}
          ></PromptDialog>
          :null
        }
        {/* 旧客户端提醒升级 */}
        <AlertSomething></AlertSomething>
    </div>
    )
  }
}

const mapDispatchToProps = (dispatch) => ({
  dispatch
})
// const mapStateToProps = (state) => ({
//   isLogIn: state.scratchGui.xesSession.isLogIn
// });

export default connect(
  mapDispatchToProps
)(smartLayer)